import * as types from "../../actionTypes";
import { toast } from "../../../UIComponents/Toast";
import { loadMedicineList } from "./medicineList";
import { client } from "../../../utils/axios";

export const updateMedicineListLoading = () => ({
  type: types.UPDATE_MEDICINIE_LIST_LOADING,
});

export const updateMedicineListSuccess = (data) => ({
  type: types.UPDATE_MEDICINIE_LIST_SUCCESS,
  payload: data,
});

export const updateMedicineListError = (error) => ({
  type: types.UPDATE_MEDICINIE_LIST_FAIL,
  payload: error,
});

export const updateMedicineList = (data) => {
  return function (dispatch) {
    dispatch(updateMedicineListLoading());
    client
      .post(
        `/doctor/update-med-item`,
        data
        // {
        //   headers: { Authorization: `Bearer ${secure_token}` },
        // }
      )
      .then((resp) => {
        dispatch(updateMedicineListSuccess(resp.data));
        dispatch(loadMedicineList());
        toast.success("Medicine updated successfully");
      })
      .catch((error) => {
        dispatch(updateMedicineListError(error.response));
      });
  };
};
